export * from './http';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
